const HIDDEN = "hidden";

/**
 * Parse UTM parameters from setting string.
 * @param {string} utmString - e.g. "google", "utm_source=google", "utm_source=google,utm_medium=cpc"
 * @returns {Object|null}
 */
function parseUtmParams(utmString) {
  if (!utmString?.trim()) return null;

  const params = {};
  for (const pair of utmString.split(",")) {
    const trimmed = pair.trim();
    if (trimmed.includes("=")) {
      const [key, value] = trimmed.split("=");
      params[key.trim()] = value.trim();
    } else {
      params.utm_source = trimmed;
    }
  }
  return Object.keys(params).length ? params : null;
}

/**
 * Check if all block UTM params exist in URL params.
 */
function utmParamsMatch(blockParams, urlParams) {
  return (
    blockParams &&
    Object.entries(blockParams).every(
      ([key, value]) => urlParams.get(key) === value
    )
  );
}

/**
 * Swap default banners for UTM-targeted ones when URL params match.
 * Default banners are server-rendered visible — this only runs when
 * UTM parameters are present in the URL.
 */
function initImageBanner() {
  const urlParams = new URLSearchParams(window.location.search);
  const hasUtmParams = [...urlParams.keys()].some((k) => k.startsWith("utm_"));

  if (!hasUtmParams) return;

  document
    .querySelectorAll("[data-dynamic-image-banner-container]")
    .forEach((section) => {
      const utmContainer = section.querySelector(
        "[data-dynamic-image-banner-utm-content]"
      );
      if (!utmContainer) return;

      const utmBlocks = utmContainer.querySelectorAll("[data-utm-source]");
      let matched = false;

      utmBlocks.forEach((block) => {
        const params = parseUtmParams(block.dataset.utmSource);
        if (utmParamsMatch(params, urlParams)) {
          block.classList.remove(HIDDEN);
          matched = true;
        }
      });

      if (matched) {
        section
          .querySelectorAll("[data-default-banner]")
          .forEach((el) => el.classList.add(HIDDEN));
        utmContainer.classList.remove(HIDDEN);
      }
    });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initImageBanner);
} else {
  initImageBanner();
}
